module.exports = __webpack_public_path__ + "static/media/add items.daddcd30.svg";